import { Link } from 'react-router-dom';
import logoWhite from '../assets/img/black_logo.png';
import footerBg from '../assets/img/banner.png';
import iconFacebook from '../assets/img/facebook.png';
import iconTwitter from '../assets/img/twitter.png';
import iconInstagram from '../assets/img/instagram.png';
import iconLinkedIn from '../assets/img/linkedin.png';

const quickLinks = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/profile', label: 'Profile' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/services', label: 'Services' },
  { to: '/contact', label: 'Contact' },
];

const travelLinks = [
  { to: '/tours', label: 'Tours' },
  { to: '/hotel', label: 'Hotel' },
  { to: '/flights', label: 'Flights' },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-navy-950">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${footerBg})` }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-navy-950/85" aria-hidden />

      <div className="relative mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          {/* Brand */}
          <div className="lg:col-span-4">
            <Link to="/" className="inline-flex items-center gap-3">
              <img
                src={logoWhite}
                alt="RAYANSTAR CONSULTANCY & SERVICES CO. W.L.L."
                className="h-16 w-auto sm:h-[4.5rem] md:h-20"
              />
            </Link>
            <p className="mt-4 max-w-md text-justify text-sm leading-relaxed text-white/75">
              RAYANSTAR Consultancy &amp; Services W.L.L. is a leading consultancy firm in Bahrain,
              providing expert services in government documentation, education consultancy, visa services,
              and event management.
            </p>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-gold/90">Quick Links</h3>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-white/75 transition hover:text-gold">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Travel */}
          <div className="lg:col-span-2">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-gold/90">Travel</h3>
            <ul className="mt-4 space-y-3">
              {travelLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-white/75 transition hover:text-gold">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Address */}
          <div className="lg:col-span-4">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-gold/90">Address</h3>
            <ul className="mt-4 space-y-3 text-sm text-white/75">
              <li className="flex items-start gap-3">
                <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/10">
                  <svg className="h-4 w-4 text-gold" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
                  </svg>
                </span>
                <span className="space-y-1 leading-snug">
                  <a className="block hover:text-gold" href="tel:+97333671305">
                    +973 3367 1305
                  </a>
                  <a className="block hover:text-gold" href="tel:+97333671307">
                    +973 3367 1307
                  </a>
                  <a className="block hover:text-gold" href="tel:+97377971307">
                    +973 7797 1307
                  </a>
                  <a className="block hover:text-gold" href="tel:+966559936507">
                    +966 55 993 6507
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/10">
                  <svg className="h-4 w-4 text-gold" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15A2.25 2.25 0 0 1 2.25 17.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15A2.25 2.25 0 0 0 2.25 6.75m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91A2.25 2.25 0 0 1 2.25 6.993V6.75" />
                  </svg>
                </span>
                <span className="space-y-1 leading-snug">
                  <a className="block hover:text-gold" href="mailto:info@rayanstar.me">
                    info@rayanstar.me
                  </a>
                  <a className="block hover:text-gold" href="mailto:rayanstarbh@gmail.com">
                    rayanstarbh@gmail.com
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white/10">
                  <svg className="h-4 w-4 text-gold" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 21s7-4.5 7-11a7 7 0 1 0-14 0c0 6.5 7 11 7 11Z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 10.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
                  </svg>
                </span>
                <span className="leading-snug">
                  Office 44, Building 2415
                  <br />
                  Road 2831, Block 428
                  <br />
                  AL-Seef, Mashtan Building
                  <br />
                  Manama, Kingdom of Bahrain
                </span>
              </li>
            </ul>

            <div className="mt-6 flex flex-wrap items-center gap-3">
              <a
                href="https://www.facebook.com/"
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 p-1.5 transition hover:bg-white/20"
                aria-label="Facebook"
              >
                <img src={iconFacebook} alt="" className="h-6 w-6 object-contain" />
              </a>
              <a
                href="https://twitter.com/"
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 p-1.5 transition hover:bg-white/20"
                aria-label="Twitter"
              >
                <img src={iconTwitter} alt="" className="h-6 w-6 object-contain" />
              </a>
              <a
                href="https://www.instagram.com/"
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 p-1.5 transition hover:bg-white/20"
                aria-label="Instagram"
              >
                <img src={iconInstagram} alt="" className="h-6 w-6 object-contain" />
              </a>
              <a
                href="https://www.linkedin.com/"
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/10 p-1.5 transition hover:bg-white/20"
                aria-label="LinkedIn"
              >
                <img src={iconLinkedIn} alt="" className="h-6 w-6 object-contain" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-center text-xs text-white/55 sm:flex-row sm:items-center sm:justify-between sm:text-left">
          <div>© {new Date().getFullYear()} RAYANSTAR Consultancy &amp; Services W.L.L. All rights reserved</div>
          <div className="flex items-center justify-center gap-4 sm:justify-end">
            <Link className="hover:text-white" to="/privacy">
              Privacy Policy
            </Link>
            <a className="hover:text-white" href="/terms">
              Terms &amp; Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
